import { memo } from 'react';

import { getScopedTranslate } from '@locale/translate';
import { abbreviateDate } from '@utils/date';

import { TravellerJourneyAction } from 'api/types';
import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

import { newDateIgnoreLocalTimezone } from '../timezone';

const ACTION_TYPE = ACTION_TYPES.wait_until_fixed_date;

export const getDescription = (action: TravellerJourneyAction<typeof ACTION_TYPE>) => {
  const { t } = getScopedTranslate(nodeLocale);
  const scheduledDate = action?.scheduledDate ?? action.values?.date?.value;
  const date = newDateIgnoreLocalTimezone(scheduledDate as string);
  return date ? t('triggersNext', { date: abbreviateDate(date, 'en', 'datetime') }) : '';
};

export const Node = memo((node: TravellerJourneyNode<typeof ACTION_TYPE>) => {
  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        node={node}
        label={getActionLabel(ACTION_TYPE)}
        descriptionText={node.data.nodeDescription}
      >
        <NodeActions node={node} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    triggersNext: 'Triggers next action on {date}',
  },
};
